import React from "react";
import { Col } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
import MagicWand from "../../../../../icons/MagicWand";

const SummaryTitle = ({ t }) => {
  return (
    <Col md="12" xs="9">
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <MagicWand />
        <h5
          className="font-size-15 mt-2 text-wrap pl-0 d-flex "
          style={{ marginLeft: "10px" }}
        >
          {t("Conversation summarization")}
        </h5>
      </div>
    </Col>
  );
};
export default withTranslation()(SummaryTitle);
